module.exports = __webpack_public_path__ + "img/404.9623a67.svg";